import React from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { listToolbarActionsRowSx } from './listToolbarStyles'

export type ListToolbarCrudActionsProps = {
  /** Thao tác phụ (chọn nhiều, xóa hàng loạt…) — trước block chuẩn */
  leading?: React.ReactNode
  /** Thêm mới */
  add?: React.ReactNode
  /** Nhập Excel */
  importAction?: React.ReactNode
  /** Nhập cập nhật Excel (round-trip editing) */
  capNhatImportAction?: React.ReactNode
  /** Xuất file */
  exportAction?: React.ReactNode
  /** Ẩn/hiện cột */
  columnPicker?: React.ReactNode
  /** Override layout (vd. gap nhỏ hơn trên màn chật). */
  sx?: SxProps<Theme>
}

/** Thứ tự cố định trên toolbar list: Thêm mới → Nhập → Nhập cập nhật → Xuất → Cột */
export const ListToolbarCrudActions: React.FC<ListToolbarCrudActionsProps> = ({
  leading,
  add,
  importAction,
  capNhatImportAction,
  exportAction,
  columnPicker,
  sx,
}) => (
  <Box sx={[listToolbarActionsRowSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])] as SxProps<Theme>}>
    {leading}
    {add}
    {importAction}
    {capNhatImportAction}
    {exportAction}
    {columnPicker}
  </Box>
)

export default ListToolbarCrudActions
